module.exports = __webpack_public_path__ + "img/LA_logo_merkki_nega.7ddfa5ed.png";